import { getToken } from "../cookie/authCookie";
import axiosInstance from "./config/axiosConfigs";

export const EventAPI = {
    getAllEvent: async function (clubId,status) {
        const response = await axiosInstance.request({
            url: `/event/${clubId}?status=${status}`,
            method: "GET",
            timeout: 20000,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    getAllEventForListOptions: async function (clubId) {
        const response = await axiosInstance.request({
            url: `/event/list/${clubId}`,
            method: "GET",
            timeout: 20000,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    getAllEventPlayer: async function (clubId, eventId, pageSize, pageNumber, searchKey,filterData) {
        const response = await axiosInstance.request({
            url: `/event/player/${eventId}/${clubId}?pageSize=${pageSize}&pageNumber=${pageNumber}&searchKey=${searchKey}`,
            method: "POST",
            timeout: 20000,
            data: filterData,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    getTotalEventPlayer: async function (clubId, eventId) {
        const response = await axiosInstance.request({
            url: `/event/player/total/${eventId}/${clubId}`,
            method: "GET",
            timeout: 8000,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    getEventPlayerGuardians: async function (playerId) {
        const response = await axiosInstance.request({
            url: `/event/player/member/${playerId}`,
            method: "GET",
            timeout: 8000,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    getEventPlayerFeesHistory: async function (playerId,eventId) {
        const response = await axiosInstance.request({
            url: `/payment-history/fee/history/${eventId}/player/${playerId}`,
            method: "GET",
            timeout: 8000,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },

    getEventParticipantFees: async function (eventId) {
        const response = await axiosInstance.request({
            url: `/participant-fee/selected/event/${eventId}`,
            method: "GET",
            timeout: 8000,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    getEventPaymentMethods: async function (eventId) {
        const response = await axiosInstance.request({
            url: `/payment-method/event/${eventId}`,
            method: "GET",
            timeout: 8000,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    getEventPlayerParticipantFee: async function (eventId,playerId) {
        const response = await axiosInstance.request({
            url: `/event/participant-fee/${eventId}/player/${playerId}`,
            method: "GET",
            timeout: 8000,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    getEventPlayerFullInfo: async function (eventId, playerId) {
        const response = await axiosInstance.request({
            url: `/event/${eventId}/info/player/${playerId}`,
            method: "GET",
            timeout: 20000,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    postCreateEvent: async function (reqData) {
        const response = await axiosInstance.request({
            url: `/event/create`,
            method: "POST",
            timeout: 5000,
            data: reqData,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    postAddFamilyMemberToPlayer: async function (reqData) {
        const response = await axiosInstance.request({
            url: `/event/family/member`,
            method: "POST",
            timeout: 5000,
            data: reqData,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    postRegisterPlayerIntoEvent: async function (reqData) {
        const response = await axiosInstance.request({
            url: `/event/player/add`,
            method: "POST",
            timeout: 5000,
            data: reqData,
            headers: { Authorization: `Bearer ${getToken()}` },
        }); 
        return response.data;
    },
    postDeleteEventRegistration: async function (reqData) {
        const response = await axiosInstance.request({
            url: `/event/player/delete`,
            method: "POST",
            timeout: 5000,
            data: reqData,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    putUpdateEvent: async function (reqData) {
        const response = await axiosInstance.request({
            url: `/event/update`,
            method: "PUT",
            timeout: 5000,
            data: reqData,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    putRemoveFamilyMemberFromPlayer: async function (reqData) {
        const response = await axiosInstance.request({
            url: `/event/remove/relation`,
            method: "PUT",
            timeout: 5000,
            data: reqData,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    putUpdateEventPlayerStatus: async function (reqData) {
        const response = await axiosInstance.request({
            url: `/event/player/status`,
            method: "PUT",
            timeout: 5000,
            data: reqData,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    putUpdateEventPlayerInfo: async function (reqData) {
        const response = await axiosInstance.request({
            url: `/event/info/update`,
            method: "PUT",
            timeout: 20000,
            data: reqData,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
}